import React from "react";
import ReactHtmlParser from "react-html-parser";
import { withRouter } from "react-router";
import Timer from "tiny-timer";
import _ from "underscore";
import Corpo from "../components/Corpo";
import * as desafioService from "../services/desafio";
import { closeGlobalLoading, globalLoading } from "../services/loading";
import { closeGlobalPopup, globalPopup } from "../services/popup";
//import socketApi from "../services/socket";
import { updateUserLS, updateUser } from "../services/user";
import { finishMatchMultiplayer } from "../services/match-service";

class TabDesafio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      me: null,
      matchId: null,
      perguntaSelecionada: null,
      currentTime: null,
      currentTimeDeg: null,
      blackoutTimer: null,
      opponent: null,
      questionAnswered: false,
      questionPanelOpen: false,
      needScroll: false,
      canUseBlackout: false,
      canUseRemove2: false,
      whoAmi: null,
      currentQuestion: null,
      currentTimeOut: null,
      opponentPaused: null,
      matchPausedAt: null,
    };
  }

  questionAnswerSusbscription = null;
  nextQuestionSusbscription = null;
  blackoutSusbscription = null;
  quitChallengeSusbscription = null;

  routeParam = this.props.location.pathname
    .replace("/tab/desafio/", "")
    .split("/");

  timer = new Timer();
  woTimer = new Timer();

  //socket = socketApi;

  trataResposta = (indexResposta) => {
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    let acabou = false;
    // Evita o uso dos botões em perguntas já respondidas
    if (!this.state.questionAnswered) {
      this.setState({ questionAnswered: true });
      this.setState({ canUseBlackout: false });
      this.setState({ canUseRemove2: false });

      let mensagem;

      let response = {
        userId: window.GLOBALS.user.info.userId,
        matchId: window.GLOBALS.actualMultiplayerMatch.info.matchId,
        questionId: this.state.perguntaSelecionada?.id,
        answerId:
          indexResposta !== null
            ? this.state.perguntaSelecionada.listaRespostas[indexResposta].id
            : null,
        matchAnswerTime: this.state.currentTime,
      };

      let localWhoAmI = this.getWhoAmI();

      // Assim que setado pode mostrar qual era a resposta certa
      let newMe = this.state.me;
      newMe.answerId = response.answerId;
      this.setState({ me: newMe });

      if (indexResposta !== null) {
        if (
          this.state.perguntaSelecionada.listaRespostas[indexResposta]
            .respostaCorreta === "S"
        ) {
          response.matchAnswerResult = 1;
          mensagem = "Parabéns!<br /><br />Você acertou.";
        } else {
          response.matchAnswerResult = 0;
          mensagem = "Que pena, desta vez você não acertou.";
        }
      } else {
        mensagem = "O seu tempo acabou!";
        acabou = false;
        response.matchAnswerResult = 0;
      }

      // Coloca um novo resultado na pilha do GLOBALS para o usuário atual
      this.pushNewResult(
        localWhoAmI,
        response.matchAnswerTime,
        response.matchAnswerResult
      );

      // Atualiza os meus resultados na tela
      if (window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI]) {
        this.setResultsOnScope(
          window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI].results,
          "me",
          response.matchAnswerResult
        );
      }

      globalPopup(
        "Atenção",
        true,
        [
          {
            texto: "OK",
            acao: () => {
              closeGlobalPopup();
              if (acabou === true) {
                this.props.history.push("/tab/jogo");
              }
            },
          },
        ],
        mensagem
      );

      this.props.stompClient.publish({
        destination: "/app/question-answer",
        body: JSON.stringify({
          response: response,
          userId: this.state.opponent.id,
        }),
      });
    }

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  };

  showMore = () => {
    this.setState({ questionPanelOpen: !this.state.questionPanelOpen });
  };

  activatePerk = (type) => {
    let localWhoAmI = this.getWhoAmI();

    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    // Evita o uso dos botões em perguntas já respondidas
    if (!this.state.questionAnswered) {
      if (
        !window.GLOBALS.actualMultiplayerMatch.info[this.state.whoAmi].perks[
          type
        ].used
      ) {
        window.GLOBALS.actualMultiplayerMatch.info[this.state.whoAmi].perks[
          type
        ].used = true;

        let scoreDebit = 0;

        if (type === "blackout") {
          this.setState({ canUseBlackout: false });
          scoreDebit = window.CONFIG.multi.scorePerBlackout;
        } else {
          this.setState({ canUseRemove2: false });
          scoreDebit = window.CONFIG.multi.scorePerRemove2;
        }

        // Já que só pode utilizar uma vez atribui
        window.GLOBALS.actualMultiplayerMatch.info[this.state.whoAmi].perks[
          type
        ].points = scoreDebit;

        this.setState({
          me: {
            ...this.state.me,
            matchPoints: this.state.me.matchPoints - scoreDebit,
            scoreDebit: scoreDebit,
          },
        });

        setTimeout(() => {
          if (localWhoAmI === "opponent") {
            window.GLOBALS.actualMultiplayerMatch.info.opponent.matchPoints = this.state.me.matchPoints;
          } else {
            window.GLOBALS.actualMultiplayerMatch.info.challenger.matchPoints = this.state.me.matchPoints;
          }

          // No caso de blackout chama o evento causando o blackout no oponente
          if (type === "blackout") {
            this.props.stompClient.publish({
              destination: "/app/blackout",
              body: JSON.stringify({
                userId: this.state.opponent.id,
                opponentMatchPoints: this.state.me.matchPoints,
              }),
            });
          } else {
            // Pega duas erradas de forma aleatória
            let ids_errados = _.pluck(
              _.shuffle(
                _.where(
                  _.clone(this.state.perguntaSelecionada?.listaRespostas),
                  {
                    respostaCorreta: "N",
                  }
                )
              ),
              "id"
            ).slice(0, 2);

            let thas = this;

            _.each(
              this.state.perguntaSelecionada?.listaRespostas,
              function (resposta, index) {
                if (ids_errados.indexOf(resposta.id) !== -1) {
                  let newPerguntaSelecionada = thas.state.perguntaSelecionada;
                  newPerguntaSelecionada.listaRespostas[index].disabled = true;
                  thas.setState({
                    perguntaSelecionada: newPerguntaSelecionada,
                  });
                }
              }
            );
          }

          updateUserLS({
            ...window.GLOBALS.user.info,
            qtdPontos: this.state.me.matchPoints,
          });

          this.blackoutAllowed(localWhoAmI, this.state.me);
          this.remove2Allowed(localWhoAmI, this.state.me);

          window.GLOBALS.user.info.qtdPontos = this.state.me.matchPoints;
          updateUser(window.GLOBALS.user.info);
          localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
        }, 200);
      }
    }
  };

  getWhoAmI = () => {
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    if (
      window.GLOBALS.actualMultiplayerMatch.info?.opponent.id.toString() ===
      window.GLOBALS.user.info.id.toString()
    ) {
      return "opponent";
    } else {
      return "challenger";
    }
  };

  pushNewResult = (whoAmIIndex, matchAnswerTime, matchAnswerResult) => {
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

    if (window.GLOBALS.actualMultiplayerMatch.info[whoAmIIndex]) {
      if (!window.GLOBALS.actualMultiplayerMatch.info[whoAmIIndex].results) {
        window.GLOBALS.actualMultiplayerMatch.info[whoAmIIndex].results = [];
      }

      window.GLOBALS.actualMultiplayerMatch.info[whoAmIIndex].results.push({
        matchAnswerTime: matchAnswerTime,
        matchAnswerResult: matchAnswerResult,
      });

      window.GLOBALS.actualMultiplayerMatch.info[whoAmIIndex].matchPoints =
        (window.GLOBALS.actualMultiplayerMatch.info[whoAmIIndex].matchPoints ||
          0) + matchAnswerResult;
    }

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  };

  setResultsOnScope = (results, who, matchAnswerResult) => {
    if (!results) return;

    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    let countQuestions = window.GLOBALS.actualMultiplayerMatch.questions.length,
      resulsSoFar = results,
      resultsToScope = [],
      countQuestionsAnswered = 0;

    for (let i = 0; i < countQuestions; i++) {
      if (resulsSoFar[i]) {
        countQuestionsAnswered++;
        resultsToScope.push(resulsSoFar[i]);
      } else {
        resultsToScope.push({
          matchAnswerTime: false,
          matchAnswerResult: false,
        });
      }
    }

    if (who === "me") {
      const meMatchPoints = this.state.me.matchPoints || 0;
      this.setState({
        me: {
          ...this.state.me,
          results: resultsToScope.reverse().map((x) => x),
          countQuestionsAnswered: countQuestionsAnswered,
          matchPoints: meMatchPoints + matchAnswerResult,
        },
      });
    }

    if (who === "opponent") {
      const opponentMatchPoints = this.state.opponent.matchPoints || 0;
      this.setState({
        opponent: {
          ...this.state.opponent,
          results: resultsToScope.reverse().map((x) => x),
          countQuestionsAnswered: countQuestionsAnswered,
          matchPoints: opponentMatchPoints + matchAnswerResult,
        },
      });
    }
  };

  receiveOpponentAnswer = (message) => {
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    const dataAnswer = JSON.parse(message.body);

    if (dataAnswer.userId !== window.GLOBALS.user.info.id) {
      // Trata o recebimento da resposta do oponente
      let localWhoAmI = this.getWhoAmI();

      // Mostra a resposta do oponente na tela
      this.setState({
        opponent: {
          ...this.state.opponent,
          answerId: dataAnswer.response.answerId,
        },
      });

      // Inverte para colocar o resultado no resultado do oponente
      let reverselocalWhoAmI =
        localWhoAmI === "challenger" ? "opponent" : "challenger";

      this.pushNewResult(
        reverselocalWhoAmI,
        dataAnswer.response.matchAnswerTime,
        dataAnswer.response.matchAnswerResult
      );

      this.setResultsOnScope(
        window.GLOBALS.actualMultiplayerMatch.info[reverselocalWhoAmI].results,
        "opponent",
        dataAnswer.response.matchAnswerResult
      );

      this.props.stompClient.publish({
        destination: "/app/next-question",
        body: JSON.stringify({
          matchId: window.GLOBALS.actualMultiplayerMatch.info.matchId,
        }),
      });
    }
  };

  receiveBlackout = (messageData) => {
    const message = JSON.parse(messageData.body);
    let localWhoAmI = this.getWhoAmI();
    let seconds = window.CONFIG.multi.secondsPerBlackout;

    let interval = setInterval(() => {
      if (seconds > 0) {
        this.setState({
          opponent: {
            ...this.state.opponent,
            matchPoints: message.opponentMatchPoints,
          },
        });
        
        this.setState({ blackoutTimer: seconds });
        seconds--;
      } else {
        this.setState({ blackoutTimer: 0 });
        clearInterval(interval);
      }
    }, 1000);

    const reverselocalWhoAmI =
        localWhoAmI === "challenger" ? "opponent" : "challenger";
    
    window.GLOBALS.actualMultiplayerMatch.info[reverselocalWhoAmI].matchPoints =
      message.opponentMatchPoints;
      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  };

  opponentQuited = (msg) => {
    const response = JSON.parse(msg.body);

    if (
      response.userId.toString() !== window.GLOBALS.user.info.id.toString() &&
      (response.userId.toString() ===
        window.GLOBALS.actualMultiplayerMatch.info.challenger.id.toString() ||
        response.userId.toString() ===
          window.GLOBALS.actualMultiplayerMatch.info.opponent.id.toString())
    ) {
      console.log("O OPONENTE ABANDONOU O JOGO", response.userId);
      this.timeOut();
    }
  };

  timeOut = () => {
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    this.timer.stop();
    this.endMatch("Você venceu seu oponente por W.O.");
  };

  endMatch = (msg) => {
    this.deRegisterAllListeners();

    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    window.GLOBALS.user.info.qtdPontos = this.state.me.matchPoints + 30;
    window.GLOBALS.isInMultiplayer = false;
    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

    //updateUser(window.GLOBALS.user.info);

    // migration refactoring - start
    let match = {
      idTema: window.GLOBALS.actualMultiplayerMatch.themeId,
      idUsuarioVencedor: window.GLOBALS.user.info.id,
      idUsuarioConvidado: window.GLOBALS.actualMultiplayerMatch.guestUserId,
      idUsuarioDesafiado: window.GLOBALS.actualMultiplayerMatch.challengedUserId,
    };

    if ( window.GLOBALS.actualMultiplayerMatch.guestUserId.toString() === window.GLOBALS.user.info.id.toString() ) {
      match.qtdPontosConvidado = 30;
      match.qtdPontosDesafiado = 0;
    }
    else {
      match.qtdPontosConvidado = 0;
      match.qtdPontosDesafiado = 30;
    }
    
    finishMatchMultiplayer(match)
    .then((_) => {
      console.error("finishMatchMultiplayer.success");
    })
    .catch((error) => {
      console.error("finishMatchMultiplayer.error: ", error);
    });
    // migration refactoring - end

    globalPopup(
      "Partida Encerrada",
      true,
      [
        {
          texto: "OK",
          acao: () => {
            this.props.history.push("/tab/jogo");
          },
        },
      ],
      msg
    );
  };

  goToNextQuestion = () => {
    if (
      this.state.me.countQuestionsAnswered ===
      this.state.opponent.countQuestionsAnswered
    ) {
      setTimeout(() => {
        closeGlobalPopup();
        window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
        closeGlobalLoading();

        // Remove todos os listeners na saída da página
        this.deRegisterAllListeners();

        // Caso esteja na última pergunta manda eles para a tela de resultado
        if (
          this.state.currentQuestion + 1 >
          window.GLOBALS.actualMultiplayerMatch.questions.length - 1
        ) {
          this.props.history.push("/tab/multi-fim");
        } else {
          this.props.history.push(
            "/tab/desafio/" + (this.state.currentQuestion + 1)
          );
        }
      }, 3000);
    }
  };

  pauseRemove = () => {
    this.setState({ matchPausedAt: _.now() });
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

    // Para o cronometro para se voltar continuar de onde parou
    this.timer.pause();

    // Avisa o oponente que sai do jogo
    // this.socket.emit(
    //   "challange:pause",
    //   window.GLOBALS.actualMultiplayerMatch.info.match.name
    // );

    // O oponente começará o timer de saída

    // Se o oponente estiver pausado também termina a partida
    if (this.state.opponentPaused) {
      // this.endMatch("Ambos jogadores abandonaram a partida.");

      // TODO: CHAMAR WEB SERVICE E TERMINAR A PARTIDA SEM VENCEDORES!!!
    }
  };

  resumeRemove = () => {
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    // Caso o usuário volte de uma pausa do jogo

    // Avisa o oponente que sai do jogo
    // this.socket.emit(
    //   "challange:resume",
    //   window.GLOBALS.actualMultiplayerMatch.info.match.name
    // );

    closeGlobalLoading();

    // Partida será retomada em
    globalLoading("Verificando status da partida.");

    // Caso tenha passado o tempo de timeout avisa ao usuário que ele perdeu de W.O.
    if (
      (_.now() - this.matchPausedAt) / 1000 >
      window.CONFIG.multi.secondsTOMulti
    ) {
      closeGlobalLoading();
      this.endMatch("Você perdeu de W.O.");
    } else {
      closeGlobalLoading();
      // Pega o resultado da mesma via WebService ???
      // TODO: Caso não seja suficiente a finalização acima fazer um temporizador
      // de segurança para que quando aconteça o problema e não retomar a partida
      // dar outro aviso de erro
      // Caso dois dois sairem
    }
  };

  currentTimeOutFn = (t) => {
    this.setState({ currentTimeOut: t / 1000 });
  };

  pauseReceive = () => {
    // Marca que o oponente pausou para caso os dois pausem a partida seja encerrada
    this.setState({ opponentPaused: true });

    // Começa o timer de W.O.
    this.woTimer = new Timer();
    this.woTimer.on("done", this.timeOut);
    this.woTimer.on("tick", this.currentTimeOutFn);
    this.woTimer.start(window.CONFIG.multi.secondsTOMulti * 1000);

    // Para a contagem da partida
    this.timer.stop();

    // Avisa o usuário e começa a contagem de timeout
    globalLoading(
      "O oponente saiu do jogo.<br /> Iniciando contagem para o W.O. <br />" +
        this.state.currentTimeOut
    );
  };

  deRegisterAllListeners = () => {
    this.questionAnswerSusbscription.unsubscribe();
    this.nextQuestionSusbscription.unsubscribe();
    this.blackoutSusbscription.unsubscribe();
    this.quitChallengeSusbscription.unsubscribe();

    // PAUSE AND RESUME RELATED EVENTS
    this.pauseRemove();
    this.resumeRemove();
    //this.socket.off("challange:resume:receive", this.resumeReceive);
    //this.socket.off("challange:pause:receive", this.pauseReceive);

    // No caso de por algum problema não ter parado o timer
    this.timer.stop();
  };

  resumeReceive = () => {
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    this.setState({ opponentPaused: false });

    if (this.state.currentTimeOut) {
      closeGlobalLoading();
      // Para o relógio de TimeOut da partida
      this.woTimer.stop();

      // Partida será retomada em
      globalLoading(
        "O oponente retornou ao jogo. Retomando a partida em alguns segundos."
      );

      // Emite o sinal de retomada da partida para ambos
      // this.socket.emit(
      //   "challange:resume:accept",
      //   window.GLOBALS.actualMultiplayerMatch.info.match.name
      // );
    }
  };

  updateTimer = (currentTime) => {
    // Se a questão ainda não for respondida atualizar o contator na tela
    if (!this.state.questionAnswered) {
      this.setState({ currentTime: Math.round(currentTime / 1000) });
    }
    // Sempre mostra quanto tempo o jogador/oponente ainda tem nessa jogada por meio do semi círculo

    if (!this.state.questionAnswered) {
      this.setState({ currentTimeDeg: Math.round(currentTime / 1000) * 3 });
    }

    if (!currentTime && !this.state.questionAnswered) {
      this.trataResposta(null);
    }
  };

  lisRemanecentes = (count) => {
    let max = count - 10;
    let arrReturn = [];

    for (let i = 0; i < max; i++) {
      arrReturn.push(i + 1);
    }

    return arrReturn;
  };

  blackoutAllowed = (localWhoAmI, localMe) => {
    if (
      window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI] &&
      window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI].perks
    ) {
      this.setState({
        canUseBlackout:
          !window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI].perks
            .blackout.used &&
          localMe.matchPoints >= window.CONFIG.multi.scorePerBlackout,
      });
    } else {
      this.setState({
        canUseBlackout: false,
      });
    }
  };

  remove2Allowed = (localWhoAmI, localMe) => {
    if (
      window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI] &&
      window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI].perks
    ) {
      this.setState({
        canUseRemove2:
          !window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI].perks.remove2
            .used && localMe.matchPoints >= window.CONFIG.multi.scorePerRemove2,
      });
    } else {
      this.setState({
        canUseRemove2: false,
      });
    }
  };

  componentWillMount = () => {
    this.questionAnswerSusbscription = this.props.stompClient.subscribe(
      `/user/${window.GLOBALS.user.info.id.toString()}/queue/question-answer`,
      this.receiveOpponentAnswer
    );
    this.nextQuestionSusbscription = this.props.stompClient.subscribe(
      `/user/${window.GLOBALS.actualMultiplayerMatch.info.matchId.toString()}/queue/next-question`,
      this.goToNextQuestion
    );
    this.blackoutSusbscription = this.props.stompClient.subscribe(
      `/user/${window.GLOBALS.user.info.id.toString()}/queue/blackout`,
      this.receiveBlackout
    );
    this.quitChallengeSusbscription = this.props.stompClient.subscribe(
      "/topic/public",
      this.opponentQuited
    );
    // this.socket.on("challange:resume:receive", this.resumeReceive);

    // this.socket.on("challange:continue", () => {
    //   closeGlobalLoading();

    //   globalLoading("Continuando a partida");

    //   setTimeout(() => {
    //     closeGlobalLoading();

    //     // Continua o timer de onde paramos
    //     this.timer.resume();
    //   }, 2000);
    // });

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

    // otras parada

    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

    let localWhoAmI = this.getWhoAmI();
    let localCurrentQuestion = parseInt(
      this.routeParam !== undefined && this.routeParam.length > 0
        ? this.routeParam[0]
        : 0
    );

    // Descobre se o usuário é o desafiante ou o desafiado
    this.setState({ whoAmi: localWhoAmI });
    this.setState({
      matchId: window.GLOBALS.actualMultiplayerMatch.info.matchId,
    });
    this.setState({ currentQuestion: localCurrentQuestion });

    this.setState({
      perguntaSelecionada:
        window.GLOBALS.actualMultiplayerMatch.questions &&
        window.GLOBALS.actualMultiplayerMatch.questions.length > 0
          ? window.GLOBALS.actualMultiplayerMatch.questions[
              localCurrentQuestion
            ]
          : {},
    });

    if (window.GLOBALS.actualMultiplayerMatch.info) {
      this.setState({
        canUseBlackout:
          window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI] &&
          !window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI].perks
            ?.blackout.used &&
          this.me?.matchPoints >= window.CONFIG.multi.scorePerBlackout,
      });
    }

    window.GLOBALS.isInMultiplayer = true;

    let localMe, localOpponent;

    if (localWhoAmI === "opponent") {
      // Se for o desafiado
      localMe = _.clone(window.GLOBALS.actualMultiplayerMatch.info.opponent);
      this.setState({ me: localMe });

      localOpponent = _.clone(
        window.GLOBALS.actualMultiplayerMatch.info.challenger
      );
      this.setState({ opponent: localOpponent });
    } else {
      // Se for o desafiante
      localMe = _.clone(window.GLOBALS.actualMultiplayerMatch.info.challenger);
      this.setState({ me: localMe });

      localOpponent = _.clone(
        window.GLOBALS.actualMultiplayerMatch.info.opponent
      );
      this.setState({ opponent: localOpponent });
    }

    // Se não tiver setado cria a estrutura de dados inicial de uso das vantagens
    if (!window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI].perks) {
      window.GLOBALS.actualMultiplayerMatch.info[localWhoAmI].perks = {
        blackout: {
          used: false,
          points: 0,
        },
        remove2: {
          used: false,
          points: 0,
        },
      };
    }

    // Libera ou não o uso do botão de blackout
    this.blackoutAllowed(localWhoAmI, localMe);
    this.remove2Allowed(localWhoAmI, localMe);

    // Preenche os dados das barras de pontuação laterais
    this.setResultsOnScope(this.me?.results, "me");
    this.setResultsOnScope(this.opponent?.results, "opponent");

    this.setState({ currentTime: window.CONFIG.multi.secondsPerQuestion });
    this.setState({ currentTimeDeg: this.state.currentTime });

    this.timer.on("tick", this.updateTimer);
    this.timer.start(window.CONFIG.multi.secondsPerQuestion * 1000);

    // Teste e controle de scroll da pergunta quando essa está muito grande
    this.setState({ needScroll: false });
    this.setState({ questionPanelOpen: false });

    // Descomentar a linha abaixo para realizar testes na tela
    //timer.stop();

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  };

  componentWillUnmount = () => {
    this.deRegisterAllListeners();
  };

  render() {
    return (
      <Corpo {...this.props}>
        <div name="tab-inicio" className="view-container tab-content">
          <div
            className="view-jogo tab-pergunta jogo-multi pane-game"
            style={{ height: "100%" }}
          >
            <div className="row desafio-users">
              <div className="col desafio-user-left">
                <p className="desafio-user-score">
                  <img
                    src={desafioService.checkImg(this.state.me?.picture)}
                    className="desafio-user-image"
                    alt="img"
                  />
                  <span>
                    {this.state.me?.matchPoints}Pts
                    <span
                      style={{
                        display: this.state.me?.scoreDebit ? "" : "none",
                      }}
                      className={this.state.me?.scoreDebit ? "show-debit" : ""}
                    >
                      -{this.state.me?.scoreDebit}
                    </span>
                  </span>
                </p>
              </div>

              <div className="col desfio-timer">
                {/*transform: rotate({ currentTimeDeg  }deg)*/}
                <div
                  style={{
                    transform: "rotate(" + this.state.currentTimeDeg + "deg)",
                    zIndex: 0,
                  }}
                  className="time-bg"
                ></div>
                <span className="desafio-timer-text">
                  {this.state.currentTime}s
                </span>
                {/*<img src="" className="desafio-timer-bg">*/}
              </div>

              <div className="col desafio-user-right">
                <p className="desafio-user-score">
                  <span>{this.state.opponent?.matchPoints}Pts</span>
                  <img
                    src={desafioService.checkImg(this.state.opponent?.picture)}
                    className="desafio-user-image"
                    alt="img"
                  />
                </p>
              </div>
            </div>

            <div
              className={
                "pergunta-panel" + (this.state.needScroll ? " has-scroll" : "")
              }
            >
              <h2 className="pergunta-title">
                Pergunta {this.state.perguntaSelecionada?.id}
              </h2>
              <div
                className={
                  "pergunta-text" +
                  (this.state.questionPanelOpen ? " full" : "")
                }
              >
                <p>
                  {ReactHtmlParser(this.state.perguntaSelecionada?.descricao)}
                </p>
                <i
                  className="icon ion-chevron-up"
                  style={{
                    display: this.state.questionPanelOpen ? "" : "none",
                  }}
                  onClick={() => this.showMore()}
                ></i>
              </div>
              <i
                className="icon ion-chevron-down"
                style={{
                  display: !this.state.questionPanelOpen ? "" : "none",
                }}
                onClick={() => this.showMore()}
              ></i>
            </div>

            <div className="perguntas-container">
              <div className="resposta-panel">
                {this.state.perguntaSelecionada?.listaRespostas?.map(
                  (resposta, key) => {
                    return (
                      <button
                        style={{
                          opacity: resposta.disabled ? "0.3" : "1",
                          cursor: resposta.disabled ? "default" : "pointer",
                        }}
                        type="button"
                        className={
                          "button button-full button-resposta" +
                          (resposta.respostaCorreta === "S" &&
                          this.state.questionAnswered
                            ? " resposta-correta"
                            : "") +
                          (resposta.respostaCorreta === "N" &&
                          this.state.questionAnswered
                            ? " resposta-errada"
                            : "")
                        }
                        onClick={() =>
                          resposta.disabled ? null : this.trataResposta(key)
                        }
                        key={key}
                      >
                        <div
                          className="my-answer"
                          style={{
                            display:
                              this.state.me.answerId === resposta.id
                                ? ""
                                : "none",
                          }}
                        >
                          <img
                            src={desafioService.checkImg(
                              this.state.me?.picture
                            )}
                            className="desafio-user-image"
                            alt="img"
                          />
                        </div>

                        <div
                          className="oponent-answer"
                          style={{
                            display:
                              this.state.questionAnswered &&
                              this.state.opponent.answerId === resposta.id
                                ? ""
                                : "none",
                          }}
                        >
                          <img
                            src={desafioService.checkImg(
                              this.state.opponent?.picture
                            )}
                            className="desafio-user-image"
                            alt="img"
                          />
                        </div>

                        <span>{ReactHtmlParser(resposta.descricao)}</span>
                      </button>
                    );
                  }
                )}
              </div>
            </div>
            <ul className="desafio-placar left">
              {this.lisRemanecentes(this.state.me?.results?.length)}
              {this.state.me?.results?.map((result, index) => {
                return (
                  <li
                    className={
                      (result.matchAnswerResult === 1 ? "certo" : "") +
                      (result.matchAnswerResult === 0 ? " errado" : "")
                    }
                    key={index}
                  >
                    <span>{index}</span>
                  </li>
                );
              })}
            </ul>

            <ul className="desafio-placar right">
              {this.state.opponent?.results?.map((result, index) => {
                return (
                  <li
                    className={
                      (result.matchAnswerResult === 1 ? "certo" : "") +
                      (result.matchAnswerResult === 0 ? " errado" : "")
                    }
                    key={index}
                  >
                    <span>{index}</span>
                  </li>
                );
              })}
            </ul>

            <div className="desafio-footer">
              <div className="row">
                <div className="col text-center">
                  <div
                    style={{
                      opacity: this.state.canUseBlackout === true ? "1" : "0.3",
                      cursor:
                        this.state.canUseBlackout === true
                          ? "pointer"
                          : "default",
                    }}
                    onClick={() =>
                      this.state.canUseBlackout === true
                        ? this.activatePerk("blackout")
                        : null
                    }
                    className="button button-full button-md button-blackout"
                  >
                    Blackout
                  </div>
                </div>
                <div className="col text-center">
                  <div
                    style={{
                      opacity: this.state.canUseRemove2 === true ? "1" : "0.3",
                      cursor:
                        this.state.canUseRemove2 === true
                          ? "pointer"
                          : "default",
                    }}
                    onClick={() =>
                      this.state.canUseRemove2 === true
                        ? this.activatePerk("remove2")
                        : null
                    }
                    className="button button-full button-md"
                  >
                    Tirar 2 erradas
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{ display: this.state.blackoutTimer ? "" : "none" }}
              className={this.state.blackoutTimer ? "blackout" : ""}
            >
              <div>
                <div>
                  O seu oponente usou um blackout contra você! O seu jogo
                  voltará ao normal em {this.state.blackoutTimer} s.
                </div>
              </div>
            </div>
          </div>
        </div>
      </Corpo>
    );
  }
}

export default withRouter(TabDesafio);
